import { render, staticRenderFns } from "./EditorCanvas.vue?vue&type=template&id=1c0bf918&scoped=true&"
import script from "./EditorCanvas.vue?vue&type=script&lang=js&"
export * from "./EditorCanvas.vue?vue&type=script&lang=js&"
import style0 from "./EditorCanvas.vue?vue&type=style&index=0&id=1c0bf918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0bf918",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c0bf918', component.options)
    } else {
      api.reload('1c0bf918', component.options)
    }
    module.hot.accept("./EditorCanvas.vue?vue&type=template&id=1c0bf918&scoped=true&", function () {
      api.rerender('1c0bf918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/ScreenEditor/ViewPort/EditorCanvas.vue"
export default component.exports